module.exports = __webpack_public_path__ + "static/media/volto.d91320d3.svg";